module.exports = __webpack_public_path__ + "static/media/like.56c3e8be.svg";